import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@lwt-helix/buttons';
import { buttonTerms } from '../../constants';
import { HelixIcon } from '@lwt-helix/helix-icon';
import { inbox } from '@lwt-helix/helix-icon/outlined';
import { exportButtonTypes } from '../constants/export';
import Loader from '@lwt-helix/loader';

const ExportButton =({onClick, isDisabled, type, isLoading}) => {
    const primaryProps = {
        color: exportButtonTypes.primary
    }
    const secondaryProps = {
        color: exportButtonTypes.secondary,
        className: 'bg-dark m-0 btn-sm mr-1 downloadBtn'
    }

    const primaryContent = (
        <div className='d-flex align-items-center justify-content-center xs-spinner'>
            {isLoading && <Loader />}
            {buttonTerms.download}
        </div>
    );
    const secondaryContent = (
        <div className='d-flex align-items-center justify-content-center xs-spinner'>
            {isLoading
                ? <div className='mr-2'><Loader /></div>
                : <HelixIcon icon={inbox} className='mr-2' />}
            {buttonTerms.download}
        </div>
    );

    const configByType = {
        primary: {
            props: primaryProps,
            content: primaryContent
        },
        secondary: {
            props: secondaryProps,
            content: secondaryContent
        }
    }

    const config = configByType[type];

    return (
        <div className='export-button-with-logo'>
            <Button
                id='downloadButton'
                dataLwtId='export'
                onClick={onClick}
                disabled={isDisabled || isLoading}
                {...config.props}
                >
                {config.content}
            </Button>
        </div>
    );
};

ExportButton.propTypes = {
    onClick: PropTypes.func,
    isDisabled: PropTypes.bool,
    type: PropTypes.string,
    isLoading: PropTypes.bool,
};

export default ExportButton;
